module.exports = __webpack_public_path__ + "img/why-icon-active-2.38e4e38a.svg";